import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function RaekUd() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ræk-ud" className="dark bg-background text-foreground relative flex min-h-[70vh] w-full items-center justify-center overflow-hidden py-20">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.03] select-none">
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-[120vh] w-[120vh] text-foreground" aria-hidden="true">
          {}
          <path d="M10 2h4v6h6v4h-6v10h-4v-10h-6v-4h6z" />
        </svg>
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        <h1 className="font-serif text-6xl font-bold tracking-tighter uppercase sm:text-8xl md:text-9xl lg:text-[10rem]">
          Ræk Ud
        </h1>
        <div className="mt-6 h-1 w-24 bg-primary mx-auto" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.07] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />
    </section>;
}